<agm-map [latitude]="coordinates.latitude" [longitude]="coordinates.longitude" style="height: 80%;"
         (mapClick)="placeMarker($event)">
  <agm-marker [latitude]="coordinates.latitude" [longitude]="coordinates.longitude" [markerDraggable]="true">
  </agm-marker>
</agm-map>

<div class="view-on-google-maps">
  <a [href]="'https://www.google.com/maps/search/' + coordinatesPlaceholder" target="_blank" rel="noopener noreferrer">
    View On Google Maps
  </a>
</div>
